import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=40c6e78c&lang=pug&"
import script from "./EditProduct.vue?vue&type=script&lang=ts&"
export * from "./EditProduct.vue?vue&type=script&lang=ts&"
import style0 from "./EditProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports